<div class="top">
    <button mat-icon-button (click)="closeSideMenu.emit()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="content">
    <div class="nav-items">
        <mat-accordion>
            <ng-container *ngFor="let item of navItems">
                @if (item.children) {
                <mat-expansion-panel (opened)="openedItem = item.nav" [expanded]="openedItem === item.nav">
                    <mat-expansion-panel-header>
                        @if (item.nav) {
                        <a class="reset-styles" [routerLink]="item.nav">
                            <div class="nav-item expansion-panel" [routerLinkActive]="'active'"
                                [class.active]="currentParent === item.nav">
                                <span>{{item.title}}</span>
                            </div>
                        </a>
                        } @else {
                        <div class="nav-item expansion-panel" [routerLinkActive]="'active'" (click)="goTo(item.goTo)"
                            [class.active]="currentParent === item.nav">
                            <span>{{item.title}}</span>
                        </div>
                        }
                    </mat-expansion-panel-header>
                    <ng-container *ngFor="let child of item.children">
                        @if (child.nav) {
                        <a class="reset-styles" [routerLink]="child.nav">
                            <div class="menu-item" [routerLinkActive]="'active'">
                                {{child.title}}
                            </div>
                        </a>
                        } @else {
                        <div class="menu-item" (click)="goTo(child.goTo)" [routerLinkActive]="'active'">
                            {{child.title}}
                        </div>
                        }
                    </ng-container>
                </mat-expansion-panel>
                } @else {
                @if (item.nav) {
                <a class="reset-styles" [routerLink]="item.nav">
                    <div class="nav-item" [class.highlight]="item.highlight" [routerLinkActive]="'active'">
                        <span>@if(item.highlight){<span class="ping" aria-hidden="true"></span>}{{item.title}}</span>
                    </div>
                </a>
                } @else {
                <div class="nav-item" [routerLinkActive]="'active'" (click)="goTo(item.goTo)">
                    <span>{{item.title}}</span>
                </div>
                }
                }
                <mat-divider></mat-divider>
            </ng-container>
            <mat-divider></mat-divider>
        </mat-accordion>
    </div>
    <div class="actions">
        <app-button [style]="'flat'" [color]="'accent'" [arrow]="true" (click)="goToContactForm()">
            Let's Talk
        </app-button>
    </div>
</div>